import { render, staticRenderFns } from "./EditorPage.vue?vue&type=template&id=b4a75b54"
import script from "./EditorPage.vue?vue&type=script&lang=js"
export * from "./EditorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports